<template>
  <div id="app">
    <!-- <navigator :currentIndex="currentIndex"></navigator> -->
    <!-- <keep-alive> -->
      <router-view />
    <!-- </keep-alive> -->
    <!-- <div v-if="(/index/ig).test($route.path)">
      <cfooter></cfooter>
    </div> -->
    <div v-if="$route.path === '/'">
      <cfooter></cfooter>
    </div>

  </div>
</template>

<script>
// import navigator from './components/navgator'
import cfooter from './components/cfooter';

export default {
    name: 'App',
    components: {
    // navigator,
        cfooter,
    },
    data() {
        return {
            currentIndex: 0,
        };
    },
    watch: {
    // $route(){
    //   this.updateActiveTag()
    // },
    },
    methods: {
    // updateActiveTag(){
    //   if(this.$route.path.indexOf('/index')>=0){
    //     this.currentIndex=0
    //     // this.$router.push({path:'/index'})
    //   }else if(this.$route.path.indexOf('/features')>=0){
    //     this.currentIndex=1
    //     // this.$router.push({path:'/features'})
    //   }/*else if(this.$route.path.indexOf('/sample')>=0){
    //     this.currentIndex=2
    //   }*/else if(this.$route.path.indexOf('/document')>=0){
    //     this.currentIndex=3
    //   }/*else if(this.$route.path.indexOf('/help')>=0){
    //     this.activeIndex=4
    //   }*/else if(this.$route.path.indexOf('/live-demo')>=0){
    //     this.currentIndex=5
    //   }
    // }
    },
    mounted() {
    // this.updateActiveTag()
    },

};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue